<template>
  <div class="container">
    <div class="header">
      <img
        src="../../../static/qi_logo.png"
        alt=""
        @click="$router.push('/')"
        style="cursor: pointer"
      />
    </div>
    <div class="section">
      <div class="box">
        <div class="box_title">取回密码</div>
        <div class="input_box">
          <el-input type="tel" v-model="phone" placeholder="手机号"></el-input>
        </div>
        <div class="input_box">
          <el-input type="tel" v-model="code" placeholder="验证码"></el-input>
          <div class="code" ref="code" @click="getCode">获取验证码</div>
        </div>
        <el-button type="primary" @click="toGetPassword">下一步</el-button>
      </div>
    </div>
    <div class="footer">
      <div style="margin-right: 10px">荷塘查策网</div>
      <div>湘ICP备2023013557号</div>
    </div>
  </div>
</template>

<script>
import { getCodeAPI } from "@/api/index";
export default {
  data() {
    return {
      phone: "",
      code: "",
      time: 60,
    };
  },
  methods: {
    getCode() {
      let timer = null;
      if (!this.phone) {
        this.$message.error("手机号不能为空");
        return;
      }
      let data = {
        phone: this.phone,
        type: "forgetpwd",
      };
      if (this.time == 60) {
        getCodeAPI(data).then((res) => {
          this.$message.success(res.data.msg);
          timer = setInterval(() => {
            this.time--;
            this.$refs.code.textContent = this.time + "s后重试";
            if (this.time == 0) {
              this.$refs.code.textContent = "获取验证码";
              this.time = 60;
              clearInterval(timer);
            }
          }, 1000);
        });
      }
    },
    toGetPassword() {
      if (!this.phone) {
        this.$message.error("手机号不能为空");
        return;
      }
      if (!this.code) {
        this.$message.error("验证码不能为空");
        return;
      }
      let tag = /^(?:(?:\+|00)86)?1\d{10}$/;
      if (!tag.test(this.phone)) {
        this.$message.error("手机号格式错误");
        return;
      }
      this.$router.push({
        path: "/getPassword",
        query: { phone: this.phone, code: this.code },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    width: 1200px;
    height: 120px;
    display: flex;
    align-items: center;
  }
  .section {
    width: 100%;
    flex: 1;
    background: #eee;
    padding-top: 100px;
    .box {
      width: 400px;
      margin: 0 auto;
      background: #fff;
      border-radius: 12px;
      padding: 0 30px 30px;
      .box_title {
        height: 50px;
        display: inline-block;
        line-height: 48px;
        border-bottom: 2px solid #409eff;
      }
      .input_box {
        margin-top: 10px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        align-items: center;
        /deep/.el-input {
          flex: 1;
        }
        .code {
          white-space: nowrap;
          margin-left: 10px;
          cursor: pointer;
        }
        .code:hover {
          color: #409eff;
        }
      }
      /deep/.el-button--primary {
        width: 100%;
        height: 50px;
        margin-top: 20px;
      }
    }
  }
  .footer {
    text-align: center;
    padding: 40px;
    display: flex;
  }
}
/deep/ .el-input__inner {
  border: 1px solid transparent;
  flex: 1;
}
</style>
